import { HomeIcon } from "@heroicons/react/24/solid";
import {
  ClipboardDocumentListIcon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  WalletIcon,
  Cog6ToothIcon,
  UserGroupIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/solid";
import { Group } from "@material-ui/icons";
import {
  FIELDPERMISSIONS,
  PERMISSIONS,
  ROUTE_PATHS,
} from "../PermissionsConstants";
export const NavBarItems = [
  {
    iconComponent: <HomeIcon className="h-4 w-4" aria-hidden="true" />,
    key: "homeKey",
    path: ROUTE_PATHS.Home,
    to: "/home",
    permission: FIELDPERMISSIONS.fieldpermission_maintab_carriertab,

    label: "HOME",
    withSub: false,
  },
  {
    iconComponent: (
      <RectangleStackIcon className="h-4 w-4" aria-hidden="true" />
    ),
    key: "CarrierAgreementMgmtKey",
    path: ROUTE_PATHS.CarrierAgreementMgmt_carriers,
    permission: FIELDPERMISSIONS.fieldpermission_maintab_carriertab,

    label: "CARRIER",
    withSub: false,
  },
  {
    iconComponent: <BuildingOfficeIcon className="h-4 w-4" />,
    key: "officeKey",
    path: ROUTE_PATHS.OfficeTab_office,
    to: "/officesettings",
    permission: FIELDPERMISSIONS.fieldpermission_maintab_officetab,
    label: "OFFICE",
    withSub: false,
  },
  {
    iconComponent: <UserGroupIcon className="h-4 w-4" />,
    key: "employeesKey",
    path: ROUTE_PATHS.EmployeeTab_employee_index,
    to: "/employeetab",
    permission: FIELDPERMISSIONS.fieldpermission_maintab_employeetab,

    label: "EMPLOYEE",
    withSub: false,
  },
  {
    iconComponent: <BuildingStorefrontIcon className="h-4 w-4" />,
    key: "vendorKey",
    path: ROUTE_PATHS.VendorTab_vendor_index,
    permission: FIELDPERMISSIONS.fieldpermission_maintab_vendortab,

    label: "VENDOR",
    withSub: false,
  },
  {
    iconComponent: <ClipboardDocumentListIcon className="h-4 w-4" />,
    key: "reportsKey",
    path: ROUTE_PATHS.ReportsTab_reports_index,
    permission: FIELDPERMISSIONS.fieldpermission_maintab_reportstab,
    label: "REPORTS",
    withSub: false,
  },
  {
    iconComponent: <WalletIcon className="h-4 w-4" />,
    key: "notificationsfeekey",
    path: ROUTE_PATHS.Notifications,
    // permission: FIELDPERMISSIONS.permission_policyfee_view,
    label: "NOTIFICATIONS",
    withSub: false,
  },
  {
    iconComponent: <Cog6ToothIcon className="h-4 w-4" />,
    key: "utilitiesKey",
    path: ROUTE_PATHS.Utilities_UserManagement_Index,
    permission: FIELDPERMISSIONS.fieldpermission_maintab_utilitiestab,
    label: "UTILITIES",
    withSub: false,
  },
];
